import { __assign } from "tslib";
import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '../../LoadingIndicator';
import ErrorBoundary from '../../ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
var LoadableRedux = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "tiercreator" */
        '../redux/creator/ModuleLoadable');
    });
});
var LoadableTierPopup = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "tierpopup" */
        './TierPopup');
    });
});
var LazyTierPopup = function (props) { return (React.createElement(ErrorBoundary, { debugComponent: "LazyTierPopup" },
    React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, { view: 'llama', withOverlay: true, usePortal: true }) },
        React.createElement(LoadableRedux, null),
        React.createElement(LoadableTierPopup, __assign({}, props))))); };
LazyTierPopup.displayName = 'LazyTierPopup';
export default LazyTierPopup;
//# sourceMappingURL=LazyTierPopup.js.map